// Return support option values
export const RETURNS_YES = 'yes';
export const RETURNS_NO = 'no';

// Returns initiation method options
export const RETURNS_INITIATION_OPTIONS = {
  SELF_SERVICE_PORTAL: 'selfServicePortal',
  MANUAL_RETURNS: 'manualReturns',
};
